import { render, staticRenderFns } from "./WillVerificationCard.vue?vue&type=template&id=1fc1269f&scoped=true"
import script from "./WillVerificationCard.vue?vue&type=script&lang=js"
export * from "./WillVerificationCard.vue?vue&type=script&lang=js"
import style0 from "./WillVerificationCard.vue?vue&type=style&index=0&id=1fc1269f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc1269f",
  null
  
)

export default component.exports